import { TakeAwayProps } from '@/interfaces/models/order';
import TakeAway from '@/models/takeAway';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((takeAwayProps: TakeAwayProps[]): TakeAway[] => {
      return takeAwayProps.map(TakeAway.createFromRequest);
    });
  }
};
